import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'error' | 'info' | 'slate';
  className?: string;
}

export const Badge = ({ children, variant = 'slate', className = '' }: BadgeProps) => {
  const variants = {
    success: 'bg-[#8dc63f]/10 text-[#76ab32] border-[#8dc63f]/20',
    warning: 'bg-amber-50 text-amber-700 border-amber-200',
    error: 'bg-rose-50 text-rose-700 border-rose-200',
    info: 'bg-blue-50 text-blue-700 border-blue-200',
    slate: 'bg-slate-50 text-slate-500 border-slate-200',
  };

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-extrabold uppercase tracking-wider border ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};



